import React, { useMemo, useState } from 'react';
import { Form, Select, DatePicker, Button, Input, Layout, Menu, Card } from 'antd';
import 'antd/dist/antd.css';
import { SoundOutlined } from '@ant-design/icons';
import { Content, Footer } from 'antd/lib/layout/layout';
import { announcementlatest, announcementtype } from '../../Services/e-pro/EproAnnounceService';

const { Option } = Select;
const { RangePicker } = DatePicker;

export const VenderAnnounce = () => {
    let [laster, setlaster] = useState<announcementtype[]>([])
    const retrieve = async () => {
        let te = await announcementlatest()
        setlaster(te)
    }

    useMemo(() => {
        retrieve();
    }, [])
    return (
        <Layout className="containers">
            <Menu mode="horizontal" defaultSelectedKeys={['1']} className="nav">
                <Menu.Item key="1" style={{ display: 'flex', alignItems: 'center' }}>หน้าแรก</Menu.Item>
                <Menu.Item key="2" style={{ display: 'flex', alignItems: 'center' }}>Supplier Portal</Menu.Item>
                <Menu.Item key="3" style={{ display: 'flex', alignItems: 'center' }}>ช่องทางการติดต่อ</Menu.Item>
                <Menu.Item key="4" style={{ display: 'flex', alignItems: 'center' }}>คู่มือการใช้งาน</Menu.Item>
            </Menu>
            <Content className="contents">
                <div className="search-section-container" >
                    <div className='search-section'>
                        <div className='search-sections'>
                            <div className='search'>
                                <h2 style={{ fontWeight: "bolder", fontSize: "40px" }}>ค้นหาประกาศจัดซื้อจัดจ้าง</h2>
                                <Form layout="vertical">
                                    <Form.Item label={<span className="custom-label">ประเภทของประกาศ</span>}>
                                        <Select placeholder="เลือกประเภทของประกาศ" style={{ fontSize: "20px" }}>
                                            <Option value="1">Option 1</Option>
                                        </Select>
                                    </Form.Item>
                                    <div className='search-group'>
                                        <Form.Item label={<span className="custom-label">หน่วยงาน</span>} style={{ width: "60%" }}>
                                            <Select placeholder="ค้นหาชื่อหน่วยงาน" style={{ fontSize: "20px" }}></Select>
                                        </Form.Item>
                                        <Form.Item label={<span className="custom-label">วันที่</span>} style={{ width: "40%" }}>
                                            <RangePicker className="custom-range-picker" />
                                        </Form.Item>
                                    </div>
                                    <Button className="search-button">
                                        ค้นหาขั้นสูง
                                    </Button>
                                </Form>
                            </div>
                            <div className="announcement-buttons">
                                <div style={{ display: 'flex', alignItems: "center", gap: '10px', padding: "10px", border: "1px solid black", borderRadius: "10px" }}>
                                    <Card bordered={false} style={{ width: 300, background: "#6598F6", borderRadius: '10px', fontSize: "30px", color: "white", display: 'flex', alignItems: 'center', justifyContent: 'center' }}> <SoundOutlined rev={undefined} style={{ color: "white", marginRight: '10px' }} />ประกาศ จัดซื้อจัดจ้าง</Card>
                                    <div style={{ borderLeft: "1px solid black", fontSize: "18px" }}>
                                        <ul >
                                            <li>ชื่อโครงการ: จัดซื้ออุปกรณ์คอมพิวเตอร์ วันที่ประกาศ: 1 มกราคม 2564</li>
                                            <li>ชื่อโครงการ: จัดซื้ออุปกรณ์คอมพิวเตอร์ วันที่ประกาศ: 2 มกราคม 2564 </li>
                                            <li>ชื่อโครงการ: จัดซื้ออุปกรณ์คอมพิวเตอร์ วันที่ประกาศ: 3 มกราคม 2564</li>
                                        </ul>
                                    </div>

                                </div>
                                <div style={{ display: 'flex', alignItems: "center", gap: '10px', padding: "10px", border: "1px solid black", borderRadius: "10px" }}>
                                    <Card bordered={false} style={{ width: 300, background: "#025A9D", borderRadius: '10px', fontSize: "30px", color: "white", display: 'flex', alignItems: 'center', justifyContent: 'center'}}> <SoundOutlined rev={undefined} style={{ color: "white", marginRight: '10px'}} />ประกาศผลการคัดเลือก</Card>
                                    <div style={{ borderLeft: "1px solid black", fontSize: "18px" }}>
                                        <ul >
                                            <li>ชื่อผู้ชนะการคัดเลือก: บริษัท ABC จำกัด วันที่ประกาศ: 15 มกราคม 2564 รายละเอียดเพิ่มเติม: <a href="#">คลิกที่นี่</a> </li>
                                            <li>ชื่อผู้ชนะการคัดเลือก: บริษัท ABC จำกัด วันที่ประกาศ: 15 มกราคม 2564 รายละเอียดเพิ่มเติม: <a href="#">คลิกที่นี่</a></li>
                                            <li>ชื่อผู้ชนะการคัดเลือก: บริษัท ABC จำกัด วันที่ประกาศ: 15 มกราคม 2564 รายละเอียดเพิ่มเติม: <a href="#">คลิกที่นี่</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="announcement-section">
                            <h2 style={{ fontWeight: "bolder", fontSize: "30px" }}>ประกาศล่าสุด</h2>
                            <ul className="announcement-list">
                                {laster.map(item => <li>{item.title}</li>)}
                                {/* <li>ประกาศ 1: จัดซื้ออุปกรณ์คอมพิวเตอร์</li>
                                <li>ประกาศ 2: จัดหาบริการดูแลระบบเครือข่าย</li>
                                <li>ประกาศ 3: จัดจ้างทำความสะอาดสำนักงาน</li>
                                <li>ประกาศ 4: จัดซื้อเครื่องพิมพ์</li>
                                <li>ประกาศ 5: จัดหาบริการบำรุงรักษาเครื่องจักร</li>
                                <li>ประกาศ 6: จัดซื้ออุปกรณ์คอมพิวเตอร์</li>
                                <li>ประกาศ 7: จัดหาบริการดูแลระบบเครือข่าย</li>
                                <li>ประกาศ 8: จัดจ้างทำความสะอาดสำนักงาน</li>
                                <li>ประกาศ 9: จัดซื้อเครื่องพิมพ์</li>
                                <li>ประกาศ 10: จัดหาบริการบำรุงรักษาเครื่องจักร</li> */}
                            </ul>
                        </div>
                    </div>

                </div>
            </Content>
        </Layout>
    );
};
